import React from "react";
import { message, Tabs, DatePicker, Row, Col, Pagination } from 'antd';
import "./ApprovedOrder.css";
import TableWidget from "./TableWidget/TableWidget";
import { TitleSearch } from "components/SearchWidget/TitleSearch";
import { useState } from "react";
import { useEffect } from "react";
import { apiDeliverOrder, apiGetOrderListApproved } from "services/orderService";
const { RangePicker } = DatePicker;

function ApprovedOrder(props) {
    const { ownCommonData, setOwnCommonData, setIsBusy } = props;
    const [searchList, setSearchList] = useState([]);

    const [totalCount, setTotalCount] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [startDate, setStartDate] = useState("");
    const [endDate, setEndDate] = useState("");

    useEffect(() => {
        setIsBusy(true)
        apiGetOrderListApproved(currentPage, pageSize, startDate, endDate)
            .then((data) => {
                setIsBusy(false)
                setOwnCommonData({ ...ownCommonData, approvedOrderList: data.approvedOrderList })
                setTotalCount(data.total_count)
            })
            .catch((err) => {
                setIsBusy(false)
                message.error("Sorry! " + err);
            });
    }, [pageSize, currentPage, startDate, endDate]);

    useEffect(() => {
        if (ownCommonData.approvedOrderList !== undefined) {
            setSearchList(ownCommonData.approvedOrderList)
        }
    }, [ownCommonData]);
    
    const onShowSizeChange: PaginationProps['onShowSizeChange'] = (current, pageSize) => {
        setPageSize(pageSize);
        setCurrentPage(current);
    };
    const onChange: PaginationProps['onChange'] = (pageNumber) => {
        setCurrentPage(pageNumber);
    };

    const handleSearch = (searchText) => {
        const tmpList = ownCommonData.approvedOrderList.filter((info) => info.customer_name.toLowerCase().includes(searchText))
        setSearchList([...tmpList])
    };
    const handleChange = (event) => {
        if (event.target.value === "") {
            setSearchList(ownCommonData.approvedOrderList)
        }
        else {
            handleSearch(event.target.value)
        }
    };
    const deliverAction = async (record) => {

        setIsBusy(true);
        apiDeliverOrder(record.id)
            .then((data) => {
                setIsBusy(false)
                ownCommonData.approvedOrderList.splice(ownCommonData.approvedOrderList.findIndex(e => e.id === data.id), 1);
                let deliveredOrderList = ownCommonData.deliveredOrderList.concat(data)
                setOwnCommonData({ ...ownCommonData, deliveredOrderList: deliveredOrderList })
            })
            .catch((err) => {
                setIsBusy(false);
                message.error("Approve Error. " + err);
            });
    }
    const handleDateFilter = (startDate, endDate) => {
        setCurrentPage(1)
        setStartDate(startDate)
        setEndDate(endDate)
    }
    return (
        <div>
            <Row>
                <Col>
                    <div style={{ fontFamily: 'mediumFont', padding: 20 }}>Date Filter Period : &nbsp;&nbsp;
                        <RangePicker size={'default'}
                            onChange={(e, date) => {
                                if (date == null) {
                                    handleDateFilter("", "")
                                } else {
                                    handleDateFilter(date[0], date[1])
                                }

                            }} />
                    </div>
                </Col>
                <Col flex={'auto'}>
                    <div style={{ fontFamily: 'mediumFont', padding: 20 }}>
                        <TitleSearch
                            onSearch={handleSearch}
                            onChange={handleChange}
                            onPressEnter={handleSearch}
                        />
                    </div>
                </Col>
            </Row>
            <Row justify={"center"}>
                <Col>
                    <Pagination
                        showSizeChanger
                        onShowSizeChange={onShowSizeChange}
                        onChange={onChange}
                        defaultCurrent={1}
                        current={currentPage}                        
                        total={totalCount}
                        pageSize={pageSize}
                    />
                </Col>
            </Row>
            <div>
                <TableWidget
                    dataList={searchList}
                    setDataList={setSearchList}
                    deliverAction={deliverAction}
                />
            </div>
        </div>
    );
}

export default ApprovedOrder;
